import React from 'react';
import { useTranslate } from 'react-admin';
import { SelectInput } from '../..';

const i18nFilters = 'components.TransactionsHistory.Filters';

interface Props {
  onChange: (e: any) => void;
  value: string;
  name?: string;
  label?: string;
  [x: string]: any;
}

export const SelectTransactionStatus = (props: Props) => {
  const { onChange, value, name, label, ...rest } = props;
  const translate = useTranslate();
  const t = (string: string) => translate(`${i18nFilters}.status.${string}`);
  return (
    <SelectInput
      label={label || t('_')}
      options={[
        { value: '', text: t('any') },
        { value: 'PENDING', text: t('PENDING') },
        { value: 'PROCESSING', text: t('PROCESSING') },
        { value: 'COMPLETED', text: t('COMPLETED') },
        { value: 'REJECTED', text: t('REJECTED') },
        { value: 'AUTHORIZED', text: t('AUTHORIZED') },
        { value: 'APPROVED', text: t('APPROVED') },
        { value: 'AWAITING_APPROVAL', text: t('AWAITING_APPROVAL') },
        // { value: 'REVERSED', text: t('REVERSED') },
      ]}
      onChange={onChange}
      value={value || ''}
      name={name || 'status'}
      {...rest}
    />
  );
};
